import React from "react";
// import ViewHandbookModal from "./ViewHandbookModal";
import EmployeeSignDocuments from "./ContractorSignDocuments";
import Button from "../../../components/Form/Button";

function DocumentVerification(props) {
  const {
    nextStep,
    signatorySubmit,
    loading,
    summaryPage,
    tabsList,
    handleGetEmployeeData,
  } = props;

  return (
    <>
      <div>
        <div className="document-verification-title-wrapper">
          <h3>Document Authorization</h3>
          <div className="document-verification-subtitle-wrapper">
            <h5>Sign Company documents</h5>
            <p>
              Sign the documents to activate payments and ensure timely employee
              payouts and tax compliance.
            </p>
          </div>
        </div>
        <div className="document-verification-table-wrapper">
          <EmployeeSignDocuments
            summaryPage={summaryPage}
            handleGetEmployeeData={handleGetEmployeeData}
          />
        </div>{" "}
        {summaryPage ? null : (
          <div className="text-end mt-4 button-flex-wrapper">
            <Button
              type="button"
              className="previous-btn"
              onClick={() => nextStep("direct_deposit")}
            >
              PREVIOUS
            </Button>
            <Button
              type="submit"
              disabled={loading}
              loading={loading}
              className="submit-btn"
              onClick={signatorySubmit}
            >
              NEXT
            </Button>
          </div>
        )}
      </div>
    </>
  );
}

export default DocumentVerification;
